import React, { useMemo } from 'react';

interface YearCalculatorProps {
  foundedYear: number | string;
  className?: string;
}

export function YearCalculator({ foundedYear, className }: YearCalculatorProps) {
  const yearInfo = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const founded = typeof foundedYear === 'string' ? parseInt(foundedYear) : foundedYear;
    
    if (!founded || isNaN(founded)) {
      return null;
    }
    
    if (founded > currentYear) {
      return {
        display: "Invalid year - cannot be in the future",
        isError: true
      };
    }
    
    const yearsOperating = currentYear - founded;
    
    return {
      display: `Founded ${founded} • ${yearsOperating} year${yearsOperating === 1 ? '' : 's'} operating`,
      isError: false
    };
  }, [foundedYear]);

  if (!yearInfo) return null;

  return (
    <p className={`text-sm ${yearInfo.isError ? 'text-destructive' : 'text-muted-foreground'} ${className}`}>
      {yearInfo.display}
    </p>
  );
}